import {CSSProperties, FC} from 'react';


export interface IIconOilProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconOil: FC<IIconOilProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M19.66 6.796v1.64c0 .133-.045.261-.127.364l-4.61 5.82-.001.003a.598.598 0 0 1-.461.22H4.93a.586.586 0 0 1-.586-.585v-.52l-2.172-2.171A.586.586 0 0 1 2 11.152V7.93c0-.324.262-.586.586-.586h5.352V6.172h-.606a.586.586 0 0 1 0-1.172h4.727a.586.586 0 0 1 0 1.172h-.606v1.172h3.008c.323 0 .586.262.586.586v.9l3.697-2.518a.586.586 0 0 1 .915.484ZM3.171 10.91l1.172 1.171V8.517H3.172v2.394Zm7.11-3.566V6.172H9.108v1.172h1.172Zm-4.766 6.328h8.359V8.516h-8.36v5.156Zm9.53-1.095 3.442-4.344v-.329l-3.441 2.344v2.33Zm5.53-.369c.19.324.41.765.62 1.242.242.55.804 1.907.804 2.65a2.346 2.346 0 0 1-2.344 2.345 2.346 2.346 0 0 1-2.344-2.344c0-.744.563-2.102.804-2.651.21-.477.43-.918.62-1.242.244-.419.499-.795.92-.795.422 0 .676.376.92.795Zm-2.092 3.893a1.173 1.173 0 0 0 2.344 0c0-.256-.188-.96-.607-1.952-.21-.497-.407-.9-.565-1.189-.157.288-.355.692-.565 1.189-.419.993-.607 1.696-.607 1.952Z" clipRule="evenodd" />
        </svg>
    );
};
